import React from "react";
import HeveaGripAboutLogo from "../../../assets/heveagriplogo.png";
import "./HeveaGripAbout.css";

const HeveaGripAbout = () => {
  return (
    <div className="Hevea-Grip-About-Page">
      <a href="https://heveagrip.com" target="_blank" rel="noopener noreferrer">
        <img
          src={HeveaGripAboutLogo}
          alt="HeveaGrip Logo"
          className="Hevea-Grip-About-Page-Logo"
        />
      </a>

      <div className="Hevea-Grip-About-Page-Container">
        <h1 className="Hevea-Grip-About-Page-Title">HeveaGrip.com</h1>
        <p className="Hevea-Grip-About-Page-Description">
          Step into the domain of HeveaGrip.com, the ultimate destination for
          comprehensive vehicle services and cutting-edge electric mobility
          solutions.
          <br />
          <br />
          Our team of seasoned professionals boasts unparalleled expertise in
          repairs, maintenance, and seamless spare parts replacement, catering
          to a diverse range of vehicles, from electric cars to traditional cars
          and motorbikes.
          <br />
          <br />
          Driven by an unwavering commitment to excellence, we prioritize the
          care of your prized vehicles, exclusively endorsing original brand
          services and authentic spare parts for every endeavor.
        </p>
      </div>
    </div>
  );
};

export default HeveaGripAbout;
